import http from "../../services/http-common";
import securityService from '../security/security.service'

class PurchaseInvoiceService {
    getForList() {
        return http.get(`/PurchaseInvoice/db/table`);
    }
    getTRNNo(AccountIDVendor) {
        return http.get(`/PurchaseInvoice/getTrnNo/${AccountIDVendor}`);
    }

    PurchaseInvoiceDetail(PurchaseInvoiceDate,PurchaseInvoiceID,   CompanyID = securityService.getCompanyIDLoggedInUserId()) {
        let queryParams = new URLSearchParams({FromDate:'01-Jan-01',ToDate:PurchaseInvoiceDate,PurchaseInvoiceID,CompanyID}).toString();
        return http.get(`/PurchaseInvoice/db/table/detail?${queryParams}`);
    }
    addPurchaseInvoice(data){
      return http.post(`/PurchaseInvoice/add`,data);
    }
    addPurchaseInvoiceDetail(data){
      return http.post(`/PurchaseInvoice/detail/add`,data);
    }

    editPurchaseInvoice(data){
      return http.put(`/PurchaseInvoice/edit`,data);
    }
    editPurchaseInvoiceDetail(data){
      return http.put(`/PurchaseInvoice/grid/edit`,data);
    }

    delete(id) {
        return http.delete(`/PurchaseInvoice/delete/${id}`);
    }
}

export default new PurchaseInvoiceService();
